<template>
  <div class="category-list">
    <a-page-header
      :title="categoryMeta?.name || category"
      :sub-title="categoryMeta?.description"
      @back="goBack"
    >
      <template #extra>
        <a-input-search
          v-model:value="filterText"
          placeholder="筛选文档..."
          style="width: 240px"
          allow-clear
        />
      </template>
    </a-page-header>

    <a-card :bordered="false" style="margin-top: 16px">
      <a-spin :spinning="loading">
        <a-list
          :data-source="filteredDocs"
          item-layout="horizontal"
        >
          <template #renderItem="{ item, index }">
            <a-list-item class="doc-item" @click="goToDoc(item.file)">
              <a-list-item-meta>
                <template #avatar>
                  <a-avatar 
                    :style="{ backgroundColor: getAvatarColor(index) }"
                    shape="square"
                  >
                    {{ index + 1 }}
                  </a-avatar>
                </template>
                <template #title>
                  <span class="doc-title">{{ item.title }}</span>
                </template>
                <template #description>
                  <span class="doc-desc">{{ item.description || '暂无描述' }}</span>
                </template>
              </a-list-item-meta>
              <template #actions>
                <RightOutlined style="color: #999" />
              </template>
            </a-list-item>
          </template>
          <template #empty>
            <a-empty description="该分类下暂无文档" />
          </template>
        </a-list>
      </a-spin>
    </a-card>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import request from '@/api/request';
import { RightOutlined } from '@ant-design/icons-vue';

export default {
  name: 'DocsCategoryList',
  components: {
    RightOutlined
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const category = ref('');
    const categoryMeta = ref(null);
    const loading = ref(false);
    const filterText = ref('');

    // 头像颜色
    const avatarColors = [
      '#1890ff', '#52c41a', '#faad14', '#f5222d', 
      '#722ed1', '#13c2c2', '#eb2f96', '#fa541c'
    ];

    const getAvatarColor = (index) => avatarColors[index % avatarColors.length];

    // 过滤后的文档列表
    const filteredDocs = computed(() => {
      if (!categoryMeta.value?.docs) return [];
      
      const filter = filterText.value.toLowerCase().trim();
      if (!filter) return categoryMeta.value.docs;
      
      return categoryMeta.value.docs.filter(doc => 
        doc.title.toLowerCase().includes(filter) ||
        (doc.description && doc.description.toLowerCase().includes(filter))
      );
    });

    // 加载分类文档
    const loadCategoryDocs = async () => {
      if (!category.value) return;
      
      loading.value = true;
      try {
        const res = await request.get(`/docs/category/${category.value}`);
        if (res.code === 200) {
          categoryMeta.value = res.data;
        }
      } catch (error) {
        console.error('加载分类文档失败:', error);
      } finally {
        loading.value = false;
      }
    };

    // 跳转到文档详情
    const goToDoc = (filename) => {
      router.push(`/docs/${category.value}/${filename}`);
    };

    // 返回
    const goBack = () => {
      router.push('/docs');
    };

    // 监听路由变化
    watch(() => route.params.category, (newCategory) => {
      if (newCategory) {
        category.value = newCategory;
        loadCategoryDocs();
      }
    }, { immediate: true });

    onMounted(() => {
      category.value = route.params.category;
      loadCategoryDocs();
    });

    return {
      category,
      categoryMeta,
      loading,
      filterText,
      filteredDocs,
      getAvatarColor,
      goToDoc,
      goBack,
    };
  }
};
</script>

<style scoped>
.category-list {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.doc-item {
  cursor: pointer;
  transition: background-color 0.3s;
  padding: 16px !important;
  border-radius: 8px;
  margin-bottom: 8px;
}

.doc-item:hover {
  background-color: #f5f5f5;
}

.doc-title {
  font-size: 15px;
  font-weight: 500;
  color: #1890ff;
}

.doc-desc {
  color: #666;
  font-size: 13px;
}
</style>

